<template>
  <section ref="fsRoot" class="maquina-estado-root">

    <!-- TOOLBAR -->
    <div class="toolbar-row">
      <div class="toolbar-left">
        <div class="toolbar-title">
          <v-icon size="16" color="#5A6476">mdi-monitor-dashboard</v-icon>
          Panel de Máquinas {{ nombreTurnoCurso ? `Datos del ${nombreTurnoCurso}` : ""}}
        </div>
        <div v-if="!loading" class="machine-count-pill">
          {{ maquinasFiltradas.length }} máquinas
        </div>
        <div class="machine-count-pill">
          Siguiente actualizacion: {{ nextUpdateLabel }}
        </div>
        <div v-if="isFullscreen && totalPagesFullscreen > 1" class="machine-count-pill">
          Pagina {{ currentPage + 1 }} de {{ totalPagesFullscreen }}
        </div>
      </div>
      <button class="fs-btn" @click="extenderPantalla">
        <v-icon size="16" class="mr-1">{{ fsIcon }}</v-icon>
        <span class="fs-btn-label">{{ fsLabel }}</span>
      </button>
    </div>

    <v-card id="projection" elevation="0" class="dashboard-card">
      <v-card-text class="dashboard-body">

        <!-- ALERTAS -->
        <v-expansion-panels v-model="panel" :disabled="disabled" class="alerts-panel mb-4">
          <v-expansion-panel>
            <v-expansion-panel-header class="alerts-header">
              <div class="d-flex align-center" style="gap:8px">
                <v-icon size="14" color="#5A6476">mdi-bell-outline</v-icon>
                Configuración de Alertas
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="mt-2">
                <v-col cols="12" md="3" sm="6">
                  <vtextfieldnumber v-model="configuracionAlerta.oee"           decimal @change="sendDataConfingAlert" label="OEE"           :min="-1" :max="100"/>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <vtextfieldnumber v-model="configuracionAlerta.disponibilidad" decimal @change="sendDataConfingAlert" label="Disponibilidad" :min="-1" :max="100"/>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <vtextfieldnumber v-model="configuracionAlerta.rendimiento"    decimal @change="sendDataConfingAlert" label="Rendimiento"    :min="-1" :max="100"/>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <vtextfieldnumber v-model="configuracionAlerta.calidad"        decimal @change="sendDataConfingAlert" label="Calidad"        :min="-1" :max="100"/>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- FILTROS DE AREA -->
        <v-autocomplete
          v-model="idArea"
          :items="areas"
          label="Área"
          item-value="idArea"
          item-text="nombre"
          hide-details
          clearable
          outlined
          dense
          class="area-select mb-4"
        />

        <!-- FILTROS DE ESTADO (chips) -->
        <div class="filter-chips mb-5">
          <button
            v-for="(filtro, idx) in filtros"
            :key="'f-'+idx"
            class="filter-chip"
            :class="{ active: filtroValor === idx }"
            :style="filtroValor === idx ? activeChipStyle(filtro.opcion) : {}"
            @click="filtroValor = idx"
          >
            <span v-if="filtro.opcion !== null" class="chip-dot" :style="{ background: colorCard(filtro.opcion) }"></span>
            {{ filtro.nombre }}
            <span class="chip-count">{{ contarFiltro(filtro.opcion) }}</span>
          </button>
        </div>

        <!-- LOADING -->
        <v-progress-linear v-if="loading" indeterminate color="primary" rounded class="mb-4"/>

        <div v-if="loading && maquinasCount === 0" class="loading-state">
          <v-progress-circular :size="64" :width="5" color="primary" indeterminate/>
          <p class="loading-text">Cargando máquinas...</p>
        </div>

        <!-- GRID DE CARDS -->
        <v-row v-if="value && (!loading || maquinasCount > 0)" justify="start" align="stretch">
          <v-col
            v-for="maquina in maquinasPagina"
            :key="'maq-'+maquina.idMaquinaIns"
            :cols="12"
            :sm="dynamicCols.sm"
            :md="dynamicCols.md"
            :lg="dynamicCols.lg"
            :xl="dynamicCols.xl"
            class="d-flex"
            style="padding: 10px"
          >
            <CardMaquinaLogis
              :item="maquina"
              style="width:100%"
              @status="cambioStatus($event, maquina)"
            />
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CardMaquinaLogis from "./MaquinaEstado/CardMaquinaLogis.vue";
import vtextfieldnumber from "@/components/VTextFieldNumber.vue";
import axios from "axios";
import { mapState } from 'vuex';
import moment from 'moment';

const STATUS_COLORS = {
  1: '#00C472',
  2: '#2B7EFF',
  3: '#FF9F00',
  4: '#E83535',
  0: '#8A95A3',
};

export default {
  name: 'MaquinaEstado',
  components: { CardMaquinaLogis, vtextfieldnumber },

  props: {
    value:  { type: Boolean, default: true },
    pollMs: { type: Number,  default: 300000 },
  },

  data: () => ({
    sinDisponibilidad: false,
    desConParosNP: true,
    isFullscreen: false,
    _paroSnapshot: Object.create(null),

    panel: 1,
    disabled: false,
    configuracionAlerta: { oee: undefined, disponibilidad: undefined, rendimiento: undefined, calidad: undefined },

    filtros: [
      { opcion: null, nombre: 'Todas'              },
      { opcion: 1,    nombre: 'Activas'             },
      { opcion: 2,    nombre: 'Sin Actividad'       },
      { opcion: 3,    nombre: 'Paros Programados'   },
      { opcion: 4,    nombre: 'Paros No Prog.'      },
    ],

    filtroValor: 0,
    loading: false,
    maquinas: [],
    instancias: [],
    loadingInstancias: false,

    interval: null,
    intervalCountdown: null,
    intervalPage: null,
    nextUpdateSeconds: 300,
    currentPage: 0,
    pageSizeFullscreen: 12,
    idArea: -1,
    areas: [],
    loadingAreas: false,
    idsMaquinasSeleccionadas: [],
    turnos: [],
    tokensCache: {},

    nombreTurnoCurso: null,
    idTurnoCurso: null,
  }),

  watch: {
    value(n) { n ? this.iniciar() : this.detener(); },
    idArea()      { this.actualizarTodo(); },
    filtroValor() { this.actualizarTodo(); },
    maquinasFiltradas() {
      this.normalizarPaginaActual();
      if (this.isFullscreen && this.totalPagesFullscreen > 1) this.iniciarPaginadoFullscreen();
      if (this.totalPagesFullscreen <= 1) this.detenerPaginadoFullscreen();
    },
    isFullscreen(n) {
      this.currentPage = 0;
      n ? this.iniciarPaginadoFullscreen() : this.detenerPaginadoFullscreen();
    },
  },

  computed: {
    ...mapState({ nombreEmpresa: 'nombreEmpresa' }),

    isNyx() {
      return (this.nombreEmpresa || '').toUpperCase() === 'NYX';
    },

    fsLabel() { return this.isFullscreen ? 'Salir de Pantalla' : 'Extender Pantalla'; },
    fsIcon()  { return this.isFullscreen ? 'mdi-arrow-collapse-all' : 'mdi-arrow-expand-all'; },

    nextUpdateLabel() {
      const total = Math.max(0, Number(this.nextUpdateSeconds) || 0);
      const minutes = Math.floor(total / 60);
      const seconds = total % 60;
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },

    umbralesNorm() {
      const n = v => (v === -1 || v == null) ? null : Number(v);
      return {
        oee:           n(this.configuracionAlerta.oee),
        disponibilidad:n(this.configuracionAlerta.disponibilidad),
        rendimiento:   n(this.configuracionAlerta.rendimiento),
        calidad:       n(this.configuracionAlerta.calidad),
      };
    },

    maquinasFiltradas() {
      const opcion = this.filtros[this.filtroValor]?.opcion ?? null;
      const source = Array.isArray(this.maquinas) ? this.maquinas : [];
      const maquinas = source.filter(m => {
        if (opcion === 1) return m.status === 1;
        if (opcion === 2) return m.status === 2;
        if (opcion === 3) return m.status === 3;
        if (opcion === 4) return m.status === 4;
        return true;
      });
      if (opcion !== null) return maquinas;

      const ordenStatus = { 3: 0, 4: 1, 1: 2, 2: 3 };
      return [...maquinas].sort((a, b) => {
        const oa = ordenStatus[a.status] ?? 99;
        const ob = ordenStatus[b.status] ?? 99;
        if (oa !== ob) return oa - ob;
        return String(a.codigoMaquina || '').localeCompare(String(b.codigoMaquina || ''), 'es', { numeric: true });
      });
    },

    maquinasCount() {
      return Array.isArray(this.maquinas) ? this.maquinas.length : 0;
    },

    maquinasActivas() {
      return Array.isArray(this.maquinas)
        ? this.maquinas.filter(m => m.status === 1)
        : [];
    },

    maquinasPagina() {
      if (!this.isFullscreen) return this.maquinasFiltradas;
      const start = this.currentPage * this.pageSizeFullscreen;
      return this.maquinasFiltradas.slice(start, start + this.pageSizeFullscreen);
    },

    totalPagesFullscreen() {
      if (!this.isFullscreen) return 1;
      return Math.max(1, Math.ceil(this.maquinasFiltradas.length / this.pageSizeFullscreen));
    },

    dynamicCols() {
      const total = this.maquinasPagina.length;
      if (this.isFullscreen) {
        if (total <= 2)  return { sm: 12, md: 6,  lg: 6, xl: 6 };
        if (total <= 4)  return { sm: 12, md: 6,  lg: 4, xl: 3 };
        return                  { sm: 12, md: 4,  lg: 3, xl: 2 };
      }
      const filtro = this.filtros[this.filtroValor]?.opcion ?? null;
      if (filtro === null)       return { sm: 12, md: 6,  lg: 4, xl: 4 };
      if (total <= 2)            return { sm: 12, md: 6,  lg: 6, xl: 6 };
      if (total <= 4)            return { sm: 12, md: 6,  lg: 4, xl: 4 };
      return                            { sm: 12, md: 6,  lg: 4, xl: 4 };
    },
  },

  mounted() {
    this.iniciar();
    const sync = () => {
      this.isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
    };
    document.addEventListener('fullscreenchange', sync);
    document.addEventListener('webkitfullscreenchange', sync);
    document.addEventListener('MSFullscreenChange', sync);
    this._syncFs = sync;
  },

  beforeDestroy() {
    this.detener();
    if (this._syncFs) {
      document.removeEventListener('fullscreenchange', this._syncFs);
      document.removeEventListener('webkitfullscreenchange', this._syncFs);
      document.removeEventListener('MSFullscreenChange', this._syncFs);
    }
  },

  methods: {
    /* ────────────────────────────────────────
       FULLSCREEN
    ──────────────────────────────────────── */
    async extenderPantalla() {
      const el = this.$refs.fsRoot;
      if (!document.fullscreenElement) {
        await el.requestFullscreen?.();
        this.isFullscreen = true;
      } else {
        await document.exitFullscreen?.();
        this.isFullscreen = false;
      }
    },

    /* ────────────────────────────────────────
       HELPERS DE COLOR / CHIP
    ──────────────────────────────────────── */
    colorCard(status) {
      return STATUS_COLORS[status] || STATUS_COLORS[0];
    },

    activeChipStyle(opcion) {
      const c = this.colorCard(opcion ?? 0);
      return {
        background: c + '15',
        color: c,
        borderColor: c + '50',
      };
    },

    contarFiltro(opcion) {
      const maquinas = Array.isArray(this.maquinas) ? this.maquinas : [];
      if (opcion === null) return maquinas.length;
      return maquinas.filter(m => m.status === opcion).length;
    },

    /* ────────────────────────────────────────
       CARGA DE DATOS (sin cambios)
    ──────────────────────────────────────── */
    toPct(v) {
      const n = Number(v);
      return Number.isFinite(n) ? (n <= 1 ? n * 100 : n) : 0;
    },

    horaActual(horas = []) {
      if (!Array.isArray(horas) || !horas.length) return null;
      const vivas = horas.filter(h => h?.pasadoOEnCurso === true);
      return vivas.length ? vivas[vivas.length - 1] : null;
    },

    slotOk(slot) {
      return (Array.isArray(slot?.cavidades) ? slot.cavidades : [])
        .reduce((acc, c) => acc + (Number(c?.piezasOk) || 0), 0);
    },

    slotActual(horas) {
      const nowMX = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'America/Mexico_City', hour12: false, hour: '2-digit', minute: '2-digit',
      }).format(new Date());
      const [nowH, nowM] = nowMX.split(':').map(Number);
      const nowMin = nowH * 60 + nowM;
      let candidato = horas?.find(h => h?.pasadoOEnCurso === true);
      if (candidato) return candidato;
      return (horas || []).find(h => {
        const [dh, dm] = String(h.desdeHora || '00:00').split(':').map(Number);
        const [hh, hm] = String(h.hastaHora || '00:00').split(':').map(Number);
        const start = dh * 60 + dm, end = hh * 60 + hm;
        return (start <= end) ? (nowMin >= start && nowMin < end) : (nowMin >= start || nowMin < end);
      }) || null;
    },

    tieneOrdenes(ep) {
      return Array.isArray(ep?.ordenes) && ep.ordenes.length > 0;
    },

    postProcesoEstados(items) {
      if (!this._paroSnapshot || typeof this._paroSnapshot !== 'object') this._paroSnapshot = {};
      const snap = { ...this._paroSnapshot };
      const b = v => v === true || v === 1 || v === '1';
      const asArr = x => Array.isArray(x) ? x : [];
      const tieneOrdenesItem = it => asArr(it._ordenes ?? it.ordenes).length > 0;

      items.forEach(it => {
        const id = it.idMaquinaIns;
        const totalParo = Number(it._paroAcumNP || 0) + Number(it._paroAcumProg || 0);
        if (b(it._paroEnCurso)) {
          it.status = b(it._paroNPEnCurso) ? 4 : 3;
        } else if (tieneOrdenesItem(it)) {
          it.status = 1;
        } else {
          const slot = this.slotActual(asArr(it._horas));
          const produjoAhora = !!slot && (this.slotOk(slot) > 0 || Number(slot?.piezasRateHora || 0) > 0);
          it.status = produjoAhora ? 1 : 2;
        }
        if (id != null) snap[id] = totalParo;
      });
      this._paroSnapshot = snap;
      return items;
    },

    nombreArticuloFromResumen(resumenArticulos) {
      const arts = resumenArticulos?.articulos || [];
      if (!arts.length) return '';
      if (arts.length === 1) return arts[0].nombre || '';
      return `${arts.length} artículos`;
    },

    adaptEPResumen(ep) {
      const r      = ep?.resumen || {};
      const horas  = Array.isArray(ep?.horas)   ? ep.horas   : [];
      const ordenes= Array.isArray(ep?.ordenes)  ? ep.ordenes : [];

      const codigosTodos = horas.reduce((acc, h) => {
        (Array.isArray(h?.cavidades) ? h.cavidades : []).forEach(t => {
          (Array.isArray(t?.articulos) ? t.articulos : []).forEach(a => {
            if (a?.codigo) acc.push(a.codigo);
          });
        });
        return acc;
      }, []);
      const codigosUnicos = [...new Set(codigosTodos)];

      let slot = horas.find(h => h?.pasadoOEnCurso === true) || null;
      if (!slot && horas.length) {
        const mNow = this.minutosHoyMX();
        slot = horas.find(h => {
          const [dh, dm] = String(h.desdeHora || '00:00').split(':').map(Number);
          const [hh, hm] = String(h.hastaHora || '00:00').split(':').map(Number);
          return this.rangoMinutos(mNow, dh * 60 + (dm || 0), hh * 60 + (hm || 0));
        }) || null;
      }

      const booly = v => v === true || v === 1 || v === '1';
      const enParo   = booly(r.hayParoEnCurso   ?? r.HayParoEnCurso);
      const paroProg = booly(r.hayParoProgramadoEnCurso   ?? r.HayParoProgramadoEnCurso);
      const paroNP   = booly(r.hayParoNoProgramadoEnCurso ?? r.HayParoNoProgramadoEnCurso);

      let status;
      if (enParo) {
        status = paroNP ? 4 : 3;
      } else if (slot) {
        const cavsHora = Array.isArray(slot?.cavidades) ? slot.cavidades : [];
        const piezasOkHora = cavsHora.reduce((acc, c) => acc + (Number(c?.piezasOk) || 0), 0);
        status = (piezasOkHora > 0 || Number(slot?.piezasRateHora || 0) > 0) ? 1 : 2;
      } else {
        const produjo = (Number(r?.piezasOkTotales || 0) + Number(r?.piezasNoOkTotales || 0)) > 0;
        status = produjo ? 1 : 2;
      }

      const cavRes  = r?.resumenCavidades || {};
      const cavs    = Array.isArray(cavRes.cavidades) ? cavRes.cavidades : [];
      const sumOkCav  = Number(cavRes?.piezasOkTotales  ?? cavs.reduce((a, c) => a + (Number(c?.piezasOk)  || 0), 0)) || 0;
      const sumNokCav = Number(cavRes?.piezasNoOkTotales?? cavs.reduce((a, c) => a + (Number(c?.piezasNoOk) || 0), 0)) || 0;

      const tcQadSegPza = ordenes.length > 0 ? Number(ordenes[0].tiempoCicloSeg ?? 0) : 0;
      const segundosParoDesdeEP = paroProg
        ? Number(r.segundosTiempoParoProgramado ?? 0)
        : Number(r.segundosTiempoParo ?? 0);

      return {
        idMaquinaIns:  ep.idMaquinaIns ?? ep.id ?? null,
        codigoMaquina: r.nombreMaquina ?? r.codigoMaquina ?? ep.nombreMaquina ?? '',

        _paroEnCurso:     enParo,
        _paroProgEnCurso: paroProg,
        _paroNPEnCurso:   paroNP,
        _paroAcumNP:      Number(r.segundosTiempoParo || 0),
        _paroAcumProg:    Number(r.segundosTiempoParoProgramado || 0),
        _horas:           horas,
        _ordenes:         ordenes,

        status,
        fechaInicio: null,
        inicioParo: null,
        tiempoCambioMoldeSeg: null,
        paroTipo: null,
        paroSubTipo: null,

        oee:            this.toPct(r.oee),
        disponibilidad: this.toPct(r.disponibilidad),
        rendimiento:    this.toPct(r.rendimiento),
        calidad:        this.toPct(r.calidad),

        pizasOk:            sumOkCav,
        pizasOkPorOrden:    sumOkCav,
        planeacionPorTurno: Number(r.piezasTeoricasTotales ?? 0),
        piezasScrap:        sumNokCav,

        tiempoParoSegundos:       segundosParoDesdeEP,
        _segundosInicialesParo:   segundosParoDesdeEP,

        ot: '-',
        idMolde:      ep.idMolde      ?? r.idMolde      ?? null,
        codigoMolde:  ep.codigoMolde  ?? r.codigoMolde  ?? null,
        articulosNombres: codigosUnicos,
        tcRealSegPza: 0,
        tcRealTxt: '—',
        tcQadSegPza,
        tcQadTxt: tcQadSegPza > 0 ? `${tcQadSegPza.toFixed(1)} seg` : '—',
      };
    },

    hoyMX() {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Mexico_City',
        year: 'numeric', month: '2-digit', day: '2-digit',
      }).format(new Date());
    },

    rangoMinutos(m, start, end) {
      return (start <= end) ? (m >= start && m < end) : (m >= start || m < end);
    },

    minutosHoyMX() {
      const [hh, mm] = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'America/Mexico_City', hour12: false, hour: '2-digit', minute: '2-digit',
      }).format(new Date()).split(':').map(Number);
      return hh * 60 + mm;
    },

    turnoActualId() {
      const m = this.minutosHoyMX();
      if (Array.isArray(this.turnos) && this.turnos.length) {
        for (const t of this.turnos) {
          if (this.rangoMinutos(m, this.timeToMin(t.inicio), this.timeToMin(t.fin))) return Number(t.idTurno);
        }
        const ordered = this.turnos
          .map(t => ({ id: Number(t.idTurno), start: this.timeToMin(t.inicio) }))
          .sort((a, b) => a.start - b.start);
        const last = ordered.filter(x => x.start <= m).pop() || ordered[ordered.length - 1];
        if (last) return last.id;
      }
      if (this.nombreEmpresa === 'CAZEL-TLT') {
        return this.rangoMinutos(m, 6 * 60, 18 * 60) ? 1 : 2;
      }
      return this.rangoMinutos(m, 19 * 60, 7 * 60) ? 1 : 2;
    },

    buildParams(idMaquinaIns) {
      return {
        idMaquinaIns,
        fechaRev:         this.hoyMX(),
        idTurno:          this.turnoActualId(),
        sinDisponibilidad:this.sinDisponibilidad,
        desConParosNP:    this.desConParosNP,
      };
    },

    getAreas() {
      this.loadingAreas = true;
      axios.get('/Areas')
        .then(r => { this.areas = (r.data || []).filter(a => a.idArea > 1); })
        .finally(() => { this.loadingAreas = false; });
    },

    async getInstancias() {
      this.loadingInstancias = true;
      try {
        const res = await axios.get('/MaquinaInstancias');
        this.instancias = res.data || [];
      } catch (e) { console.log(e); }
      finally { this.loadingInstancias = false; }
    },

    val(obj, ...keys) {
      for (const key of keys) {
        if (obj && obj[key] !== undefined && obj[key] !== null) return obj[key];
      }
      return undefined;
    },

    arr(value) {
      return Array.isArray(value) ? value : [];
    },

    bool(value) {
      return value === true || value === 1 || value === '1';
    },

    num(value, fallback = 0) {
      const n = Number(value);
      return Number.isFinite(n) ? n : fallback;
    },

    formatLocalDateTime(date) {
      const pad = n => String(n).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },

    rangoFechasTurnoCurso() {
      const today = this.hoyMX();
      const turno = this.turnos.find(t => Number(t?.idTurno) === Number(this.idTurnoCurso));

      if (!turno?.inicio || !turno?.fin) {
        const inicio = new Date(`${today}T00:00:00`);
        const fin = new Date(`${today}T23:59:59`);
        return {
          inicio: this.formatLocalDateTime(inicio),
          fin: this.formatLocalDateTime(fin),
        };
      }

      const inicioMin = this.timeToMin(turno.inicio);
      const finMin = this.timeToMin(turno.fin);
      const nowMin = this.minutosHoyMX();
      const inicio = new Date(`${today}T${turno.inicio}`);
      const fin = new Date(`${today}T${turno.fin}`);

      if (inicioMin > finMin) {
        if (nowMin < finMin) {
          inicio.setDate(inicio.getDate() - 1);
        } else {
          fin.setDate(fin.getDate() + 1);
        }
      }

      return {
        inicio: this.formatLocalDateTime(inicio),
        fin: this.formatLocalDateTime(fin),
      };
    },

    idsParaConsulta() {
      if (this.idsMaquinasSeleccionadas?.length) {
        return this.idsMaquinasSeleccionadas.filter(Boolean);
      }

      if (this.idArea > 1) {
        return (this.instancias || [])
          .filter(x => Number(this.val(x, 'idArea', 'IdArea')) === Number(this.idArea))
          .map(x => this.val(x, 'idMaquinaIns', 'IdMaquinaIns'))
          .filter(Boolean);
      }

      return [];
    },

    buildQueryV2(ids, extra = {}) {
      const params = new URLSearchParams();
      ids.forEach(id => params.append('idsMaquinasIns', id));
      Object.keys(extra).forEach(key => {
        if (extra[key] !== undefined && extra[key] !== null) params.append(key, extra[key]);
      });
      return params.toString();
    },

    async getEstadoMaquinasV2(ids) {
      const query = this.buildQueryV2(ids);
      const url = `/OEEV2/EstadoMaquinasTiempoReal${query ? `?${query}` : ''}`;
      const { data } = await axios.get(url);
      return Array.isArray(data) ? data : [];
    },

    async getReporteOeeMaquinasV2(ids) {
      const rango = this.rangoFechasTurnoCurso();
      const query = this.buildQueryV2(ids, {
        inicio: rango.inicio,
        fin: rango.fin,
        calcularPorHoras: true,
      });
      const { data } = await axios.get(`/OEEV2/ReporteOEEMultiplesMaquinas?${query}`);
      return Array.isArray(data) ? data : [];
    },

    statusDesdeEstado(estado) {
      if (this.bool(this.val(estado, 'EnParoNoProgramado', 'enParoNoProgramado'))) return 4;
      if (this.bool(this.val(estado, 'EnParoProgramado', 'enParoProgramado'))) return 3;
      if (this.bool(this.val(estado, 'TieneParoAbierto', 'tieneParoAbierto'))) {
        const paro = this.primerParo(estado);
        const programado = this.val(paro, 'SubParoTipoProgramado', 'subParoTipoProgramado', 'ParoTipoProgramado', 'paroTipoProgramado');
        return this.bool(programado) ? 3 : 4;
      }
      if (this.bool(this.val(estado, 'TieneOperacionAbierta', 'tieneOperacionAbierta'))) return 1;
      return 2;
    },

    primeraOperacion(estado) {
      return this.arr(this.val(estado, 'OperacionesAbiertas', 'operacionesAbiertas'))[0] || {};
    },

    primerParo(estado) {
      return this.arr(this.val(estado, 'ParosAbiertos', 'parosAbiertos'))[0] || {};
    },

    oeeReporte(reporte) {
      return this.val(reporte, 'OEECalculado', 'oeeCalculado') || {};
    },

    operacionesReporte(reporte) {
      return this.arr(this.val(reporte, 'ODTs', 'odts')).reduce((acc, odt) => {
        this.arr(this.val(odt, 'Operaciones', 'operaciones')).forEach(op => acc.push(op));
        return acc;
      }, []);
    },

    firstNumberDeep(obj, keys, depth = 0) {
      if (!obj || depth > 4) return 0;
      if (Array.isArray(obj)) {
        for (const item of obj) {
          const found = this.firstNumberDeep(item, keys, depth + 1);
          if (found > 0) return found;
        }
        return 0;
      }
      if (typeof obj !== 'object') return 0;

      for (const key of Object.keys(obj)) {
        if (keys.includes(key.toLowerCase())) {
          const n = Number(obj[key]);
          if (Number.isFinite(n) && n > 0) return n;
        }
      }

      for (const key of Object.keys(obj)) {
        const found = this.firstNumberDeep(obj[key], keys, depth + 1);
        if (found > 0) return found;
      }
      return 0;
    },

    tcRecetaOperacion(operacion) {
      const minutosUnidad = this.num(this.val(operacion, 'TiempoMinXUnidad', 'tiempoMinXUnidad'), null);
      if (minutosUnidad > 0) return minutosUnidad * 60;

      const directo = this.num(this.val(
        operacion,
        'TiempoCicloSeg',
        'tiempoCicloSeg',
        'TiempoCiclo',
        'tiempoCiclo',
        'TiempoCicloSegundos',
        'tiempoCicloSegundos'
      ), 0);
      if (directo > 0) return directo;

      const minutosDeep = this.firstNumberDeep(operacion, ['tiempominxunidad']);
      if (minutosDeep > 0) return minutosDeep * 60;

      return this.firstNumberDeep(operacion, [
        'tiempocicloseg',
        'tiempociclo',
        'tiempociclosegundos',
      ]);
    },

    tcRecetaDesdeReporte(operaciones) {
      const valores = operaciones
        .map(op => this.tcRecetaOperacion(op))
        .filter(v => Number.isFinite(v) && v > 0);
      return valores.length ? valores[0] : 0;
    },

    textoTc(segundos) {
      const n = Number(segundos);
      if (!Number.isFinite(n) || n <= 0) return null;
      return `${n.toFixed(n >= 10 ? 0 : 1)} seg`;
    },

    adaptMaquinaV2(estado, reporte = {}) {
      const op = this.primeraOperacion(estado);
      const paro = this.primerParo(estado);
      const oee = this.oeeReporte(reporte);
      const operacionesReporte = this.operacionesReporte(reporte);
      const articulosEstado = this.arr(this.val(estado, 'Articulos', 'articulos'));
      const moldesEstado = this.arr(this.val(estado, 'Moldes', 'moldes'));
      const odtsEstado = this.arr(this.val(estado, 'ODTs', 'odts'));

      const articulos = articulosEstado.length
        ? articulosEstado
        : operacionesReporte.map(x => ({
            CodigoArticulo: this.val(x, 'CodigoArticulo', 'codigoArticulo'),
            NombreArticulo: this.val(x, 'NombreArticulo', 'nombreArticulo'),
          }));

      const moldes = moldesEstado.length
        ? moldesEstado
        : this.arr(this.val(op, 'Moldes', 'moldes'));

      const status = this.statusDesdeEstado(estado);
      const inicioParo = this.val(paro, 'InicioParo', 'inicioParo');
      const tiempoParo = this.num(this.val(paro, 'TiempoAbiertoSegundos', 'tiempoAbiertoSegundos'));
      const idMaquinaIns = this.val(estado, 'IdMaquinaIns', 'idMaquinaIns');
      const operacionesEstado = [
        op,
        ...this.arr(this.val(op, 'OperacionesRealesAbiertas', 'operacionesRealesAbiertas')),
      ];
      const tcRecetaSeg = this.tcRecetaDesdeReporte(
        operacionesReporte.length ? operacionesReporte : operacionesEstado
      );

      return {
        idMaquinaIns,
        codigoMaquina: this.val(estado, 'NombreInstancia', 'nombreInstancia') || this.val(reporte, 'NombreMaquina', 'nombreMaquina') || '',
        nombreArea: this.val(estado, 'NombreArea', 'nombreArea') || '',
        idArea: this.val(estado, 'IdArea', 'idArea') || null,
        status,

        fechaInicio: inicioParo || this.val(op, 'Inicio', 'inicio'),
        inicioParo: inicioParo ? moment(inicioParo).format('HH:mm:ss') : null,
        paroTipo: this.val(paro, 'ParoTipo', 'paroTipo') || null,
        paroSubTipo: this.val(paro, 'SubParoTipo', 'subParoTipo') || null,
        tiempoParoSegundos: tiempoParo,
        _segundosInicialesParo: tiempoParo,

        oee: this.num(this.val(oee, 'OEE', 'oee'), null),
        disponibilidad: this.num(this.val(oee, 'Disponibilidad', 'disponibilidad'), null),
        rendimiento: this.num(this.val(oee, 'Rendimiento', 'rendimiento'), null),
        calidad: this.num(this.val(oee, 'Calidad', 'calidad'), null),

        pizasOk: this.num(this.val(oee, 'PiezasOk', 'piezasOk')),
        pizasOkPorOrden: this.num(this.val(oee, 'PiezasOk', 'piezasOk')),
        planeacionPorTurno: this.num(this.val(oee, 'PiezasEsperadas', 'piezasEsperadas')),
        piezasScrap: this.num(this.val(oee, 'PiezasNoOk', 'piezasNoOk')),

        ot: this.val(odtsEstado[0], 'Clave', 'clave') || this.val(op, 'Clave', 'clave') || '-',
        nombreArticulo: this.val(articulos[0], 'NombreArticulo', 'nombreArticulo') || '',
        articulosNombres: [...new Set(articulos
          .map(a => this.val(a, 'CodigoArticulo', 'codigoArticulo') || this.val(a, 'NombreArticulo', 'nombreArticulo'))
          .filter(Boolean))],
        idMolde: this.val(moldes[0], 'IdMolde', 'idMolde') || null,
        codigoMolde: this.val(moldes[0], 'NombreMolde', 'nombreMolde') || null,

        tcRealSegPza: 0,
        tcRealTxt: null,
        tcQadSegPza: tcRecetaSeg,
        tcQadTxt: this.textoTc(tcRecetaSeg),

        _estadoTiempoReal: estado,
        _reporteOee: reporte,
      };
    },

    statusDesdeOpeTarjeta(tarjeta) {
      if (this.bool(this.val(tarjeta, 'enParo', 'EnParo'))) return 4;
      if (this.bool(this.val(tarjeta, 'activo', 'Activo'))) return 1;
      return 2;
    },

    adaptOpeTiempoRealTarjeta(tarjeta) {
      const idOperadorReal = this.val(tarjeta, 'idOperadorReal', 'IdOperadorReal');
      const idOperacionReal = this.val(tarjeta, 'idOperacionReal', 'IdOperacionReal');
      const idMaquinaIns = this.val(tarjeta, 'idMaquinaIns', 'IdMaquinaIns');
      const articulo = this.val(tarjeta, 'articulo', 'Articulo') || '';
      const clave = this.val(tarjeta, 'clave', 'Clave') || '-';
      const maquina = this.val(tarjeta, 'maquina', 'Maquina') || '';
      const paroActual = this.val(tarjeta, 'paroActual', 'ParoActual') || {};
      const inicioParo = this.val(paroActual, 'inicio', 'Inicio');
      const duracionParo = Math.trunc(this.num(this.val(paroActual, 'duracionSegundos', 'DuracionSegundos')));

      return {
        idMaquinaIns: `ope-${idMaquinaIns || maquina}`,
        idMaquinaInsOrigen: idMaquinaIns,
        idOperadorReal,
        idOperacionReal,
        codigoMaquina: maquina,
        operadorNombre: this.val(tarjeta, 'operador', 'Operador') || '',
        nombreArea: this.val(tarjeta, 'area', 'Area') || '',
        idArea: this.val(tarjeta, 'idArea', 'IdArea') || null,
        status: this.statusDesdeOpeTarjeta(tarjeta),
        statusLabel: this.val(tarjeta, 'estado', 'Estado') || null,

        fechaInicio: inicioParo || this.val(tarjeta, 'inicio', 'Inicio') || null,
        inicioParo: inicioParo ? moment(inicioParo).format('HH:mm:ss') : null,
        paroTipo: this.val(paroActual, 'paroTipo', 'ParoTipo') || null,
        paroSubTipo: this.val(paroActual, 'subParoTipo', 'SubParoTipo') || null,
        tiempoParoSegundos: duracionParo,
        _segundosInicialesParo: duracionParo,

        oee: this.num(this.val(tarjeta, 'ope', 'Ope', 'OPE'), null),
        disponibilidad: this.num(this.val(tarjeta, 'disponibilidad', 'Disponibilidad'), null),
        rendimiento: this.num(this.val(tarjeta, 'productividad', 'Productividad'), null),
        calidad: this.num(this.val(tarjeta, 'calidad', 'Calidad'), null),

        pizasOk: this.num(this.val(tarjeta, 'cantidadOk', 'CantidadOk')),
        pizasOkPorOrden: this.num(this.val(tarjeta, 'cantidadOk', 'CantidadOk')),
        cantidadOkActual: this.num(this.val(tarjeta, 'cantidadOkActual', 'CantidadOkActual')),
        cantidadOkAcumuladaOdt: this.num(this.val(tarjeta, 'cantidadOkAcumuladaOdt', 'CantidadOkAcumuladaOdt')),
        cantidadPlaneadaOdt: this.num(this.val(tarjeta, 'cantidadPlaneadaOdt', 'CantidadPlaneadaOdt')),
        planeacionPorTurno: this.num(this.val(tarjeta, 'cantidadPendienteOdt', 'CantidadPendienteOdt')),
        piezasScrap: this.num(this.val(tarjeta, 'cantidadScrap', 'CantidadScrap')),

        ot: clave,
        nombreArticulo: articulo,
        articulosNombres: articulo ? [articulo] : [],
        idMolde: null,
        codigoMolde: null,

        tcRealSegPza: this.num(this.val(tarjeta, 'tcOperadorSegundos', 'TcOperadorSegundos')),
        tcRealTxt: this.textoTc(this.val(tarjeta, 'tcOperadorSegundos', 'TcOperadorSegundos')),
        tcQadSegPza: 0,
        tcQadTxt: null,

        _esOpeTiempoReal: true,
        _opeTiempoReal: tarjeta,
      };
    },

    claveMaquinaOpe(item) {
      return item?.idMaquinaInsOrigen || item?.codigoMaquina || item?.idMaquinaIns;
    },

    prioridadMaquinaOpe(item) {
      if (item?.status === 4) return 4;
      if (item?.status === 3) return 3;
      if (item?.status === 1) return 2;
      return 1;
    },

    elegirMaquinaOpe(actual, candidato) {
      if (!actual) return candidato;

      const prioridadActual = this.prioridadMaquinaOpe(actual);
      const prioridadCandidato = this.prioridadMaquinaOpe(candidato);
      if (prioridadCandidato !== prioridadActual) {
        return prioridadCandidato > prioridadActual ? candidato : actual;
      }

      const opeActual = Number(actual?.oee) || 0;
      const opeCandidato = Number(candidato?.oee) || 0;
      if (opeCandidato !== opeActual) {
        return opeCandidato > opeActual ? candidato : actual;
      }

      const okActual = Number(actual?.cantidadOkActual ?? actual?.pizasOk) || 0;
      const okCandidato = Number(candidato?.cantidadOkActual ?? candidato?.pizasOk) || 0;
      return okCandidato > okActual ? candidato : actual;
    },

    deduplicarMaquinasOpe(items) {
      const porMaquina = new Map();
      items.forEach(item => {
        const key = this.claveMaquinaOpe(item);
        porMaquina.set(key, this.elegirMaquinaOpe(porMaquina.get(key), item));
      });
      return [...porMaquina.values()];
    },

    extraerTarjetasOpe(data) {
      const candidatos = [
        data,
        data?.$values,
        data?.tarjetas,
        data?.tarjetas?.$values,
        data?.Tarjetas,
        data?.Tarjetas?.$values,
        data?.data,
        data?.data?.$values,
        data?.Data,
        data?.Data?.$values,
        data?.data?.tarjetas,
        data?.data?.tarjetas?.$values,
        data?.data?.Tarjetas,
        data?.data?.Tarjetas?.$values,
        data?.Data?.tarjetas,
        data?.Data?.tarjetas?.$values,
        data?.Data?.Tarjetas,
        data?.Data?.Tarjetas?.$values,
        data?.result,
        data?.result?.$values,
        data?.Result,
        data?.Result?.$values,
        data?.result?.tarjetas,
        data?.result?.tarjetas?.$values,
        data?.result?.Tarjetas,
        data?.result?.Tarjetas?.$values,
        data?.Result?.tarjetas,
        data?.Result?.tarjetas?.$values,
        data?.Result?.Tarjetas,
        data?.Result?.Tarjetas?.$values,
        data?.respuesta,
        data?.respuesta?.$values,
        data?.Respuesta,
        data?.Respuesta?.$values,
        data?.respuesta?.tarjetas,
        data?.respuesta?.tarjetas?.$values,
        data?.Respuesta?.Tarjetas,
        data?.Respuesta?.Tarjetas?.$values,
      ];

      return candidatos.find(Array.isArray) || [];
    },

    async getOpeTiempoReal() {
      const { data } = await axios.get('/OPE/TiempoReal');
      const tarjetas = this.extraerTarjetasOpe(data);

      if (!tarjetas.length) {
        console.warn('OPE/TiempoReal sin tarjetas detectables:', data);
      }

      const idArea = Number(this.idArea);
      const items = tarjetas
        .filter(t => idArea > 1 ? Number(this.val(t, 'idArea', 'IdArea')) === idArea : true)
        .map(t => this.adaptOpeTiempoRealTarjeta(t));

      return this.deduplicarMaquinasOpe(items);
    },

    async obtenerDatos() {
      if (this.loading) return;
      this.loading = true;
      try {
        this.maquinas = await this.getOpeTiempoReal();
      } catch (e) {
        console.log(e);
        this.maquinas = [];
      }
      finally { this.loading = false; }
    },

    async getTurnos() {
      try {
        const { data } = await axios.get('/Turnos');
        this.turnos = Array.isArray(data) ? data : [];

        if (!this.turnos.length) {
          this.idTurnoCurso = null;
          this.nombreTurnoCurso = null;
          return;
        }

        const m = this.minutosHoyMX();
        let turnoCurso = this.turnos.find(t =>
          this.rangoMinutos(m, this.timeToMin(t?.inicio), this.timeToMin(t?.fin))
        );

        if (!turnoCurso) {
          const ordered = this.turnos
            .map(t => ({ ...t, start: this.timeToMin(t?.inicio) }))
            .sort((a, b) => a.start - b.start);
          turnoCurso = ordered.filter(t => t.start <= m).pop() || ordered[ordered.length - 1];
        }

        this.idTurnoCurso = Number(turnoCurso?.idTurno) || null;
        this.nombreTurnoCurso = turnoCurso?.nombre || null;
      } catch (e) {
        console.log(e);
        this.turnos = [];
        this.idTurnoCurso = null;
        this.nombreTurnoCurso = null;
        this.idTurnoCurso = null;
        this.nombreTurnoCurso = null;
      }
    },
    async getTurnos() {
      try {
        const { data } = await axios.get('/Turnos');
        this.turnos = Array.isArray(data) ? data : [];

        if (!this.turnos.length) {
          this.idTurnoCurso = null;
          this.nombreTurnoCurso = null;
          return;
        }

        const m = this.minutosHoyMX();
        let turnoCurso = this.turnos.find(t =>
          this.rangoMinutos(m, this.timeToMin(t?.inicio), this.timeToMin(t?.fin))
        );

        if (!turnoCurso) {
          const ordered = this.turnos
            .map(t => ({ ...t, start: this.timeToMin(t?.inicio) }))
            .sort((a, b) => a.start - b.start);
          turnoCurso = ordered.filter(t => t.start <= m).pop() || ordered[ordered.length - 1];
        }

        this.idTurnoCurso = Number(turnoCurso?.idTurno) || null;
        this.nombreTurnoCurso = turnoCurso?.nombre || null;
      } catch (e) {
        console.log(e);
        this.turnos = [];
        this.idTurnoCurso = null;
        this.nombreTurnoCurso = null;
      }
    },

    timeToMin(hms = '00:00:00') {
      const [hh = '00', mm = '00'] = String(hms).split(':');
      return Number(hh) * 60 + Number(mm);
    },

    /* ── TC Realtime (sin cambios) ── */
    async obtenerTokensMaquina(idMaquinaIns) {
      if (this.tokensCache[idMaquinaIns]) return this.tokensCache[idMaquinaIns];
      try {
        const { data } = await axios.get('/SensorDatos/TokensPorMaquina', { params: { idMaquinaIns } });
        const tokens = Array.isArray(data) ? data : [];
        if (tokens.length) this.tokensCache[idMaquinaIns] = tokens;
        return tokens;
      } catch (e) {
        console.error(`Error tokens máquina ${idMaquinaIns}:`, e);
        return [];
      }
    },

    async obtenerTcRealtimeMaquina(maquina) {
      if (this.isNyx) return;
      if (maquina?._esOpeTiempoReal) return;
      if (!maquina || maquina.status !== 1) return;
      const tokens = await this.obtenerTokensMaquina(maquina.idMaquinaIns);
      if (!tokens?.length) return;

      try {
        const fin = moment();
        const inicio = moment().subtract(15, 'minutes');
        const params = {
          inicio: inicio.format('YYYY-MM-DD HH:mm:ss'),
          fin:    fin.format('YYYY-MM-DD HH:mm:ss'),
          idMaquinaIns: maquina.idMaquinaIns,
          key: tokens[0],
        };
        const resp = await axios.get('/SensorDatos/SeriesRealtime', { params });
        const series = resp.data?.series || [];
        if (series.length && series[0].data?.length) {
          const ultimo = series[0].data[series[0].data.length - 1];
          const tc = Number(ultimo.y);
          if (Number.isFinite(tc) && tc > 0) {
            maquina.tcRealSegPza = tc;
            maquina.tcRealTxt    = `${tc.toFixed(1)} seg`;
          }
        }
      } catch (e) {
        console.error(`Error TC realtime máquina ${maquina.idMaquinaIns}:`, e);
      }
    },

    async obtenerTcRealtimeTodasActivas() {
      if (this.isNyx) return;
      if (!this.maquinasActivas.length) return;
      await Promise.allSettled(this.maquinasActivas.map(m => this.obtenerTcRealtimeMaquina(m)));
    },

    resetCountdown() {
      this.nextUpdateSeconds = Math.max(1, Math.round(this.pollMs / 1000));
    },

    iniciarCountdown() {
      if (this.intervalCountdown) return;
      this.resetCountdown();
      this.intervalCountdown = setInterval(() => {
        this.nextUpdateSeconds = Math.max(0, this.nextUpdateSeconds - 1);
      }, 1000);
    },

    detenerCountdown() {
      if (!this.intervalCountdown) return;
      clearInterval(this.intervalCountdown);
      this.intervalCountdown = null;
    },
    normalizarPaginaActual() {
      if (this.currentPage >= this.totalPagesFullscreen) {
        this.currentPage = 0;
      }
    },

    avanzarPaginaFullscreen() {
      if (!this.isFullscreen || this.totalPagesFullscreen <= 1) return;
      this.currentPage = (this.currentPage + 1) % this.totalPagesFullscreen;
    },

    iniciarPaginadoFullscreen() {
      if (this.intervalPage || this.totalPagesFullscreen <= 1) return;
      this.intervalPage = setInterval(() => this.avanzarPaginaFullscreen(), 30000);
    },

    detenerPaginadoFullscreen() {
      if (!this.intervalPage) return;
      clearInterval(this.intervalPage);
      this.intervalPage = null;
    },

    async actualizarTodo() {
      await this.obtenerDatos();
      await this.obtenerTcRealtimeTodasActivas();
      this.resetCountdown();
      this.normalizarPaginaActual();
      this.iniciarPaginadoFullscreen();
    },

    async iniciar() {
      await this.getInstancias();
      await this.getTurnos();
      this.getAreas();
      this.getDataConfingAlert();
      await this.actualizarTodo();
      if (this.interval) return;
      this.interval = setInterval(() => this.actualizarTodo(), this.pollMs);
      this.iniciarCountdown();
    },

    detener() {
      if (this.interval) { clearInterval(this.interval); this.interval = null; }
      this.detenerCountdown();
      this.detenerPaginadoFullscreen();
    },

    cambioStatus(value, maquina) { maquina.status = value; },

    sendDataConfingAlert() {
      const num = v => isNaN(parseFloat(v)) ? null : parseFloat(v);
      axios.post('/OEEAlertas/GuardarIndicadoresOEEAlerta', {
        rendimiento:    num(this.configuracionAlerta.rendimiento),
        calidad:        num(this.configuracionAlerta.calidad),
        disponibilidad: num(this.configuracionAlerta.disponibilidad),
        oee:            num(this.configuracionAlerta.oee),
      }).catch(e => console.log(e));
    },

    getDataConfingAlert() {
      axios.get('/OEEAlertas/IndicadoresOEEAlerta').then(({ data }) => {
        if (data?.calidad        != null) this.configuracionAlerta.calidad        = data.calidad;
        if (data?.disponibilidad != null) this.configuracionAlerta.disponibilidad = data.disponibilidad;
        if (data?.oee            != null) this.configuracionAlerta.oee            = data.oee;
        if (data?.rendimiento    != null) this.configuracionAlerta.rendimiento    = data.rendimiento;
      }).catch(e => console.log(e));
    },
  },
};
</script>

<style>
/* ===================================================
   TOKENS GLOBALES (sin scoped para fullscreen)
   =================================================== */
.maquina-estado-root {
  --clr-surface: #F0F2F6;
  --clr-border:  rgba(0,0,0,0.07);
  --clr-text-primary:   #0D1117;
  --clr-text-secondary: #5A6476;
  --clr-text-muted:     #8A95A3;
  --font-primary: 'Space Grotesk', 'Roboto', sans-serif;
  background: #F4F6F9;
  transition: all 0.4s ease;
}

/* ===================================================
   TOOLBAR
   =================================================== */
.toolbar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 12px;
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.toolbar-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-primary);
  font-size: 15px;
  font-weight: 600;
  color: var(--clr-text-primary);
}

.machine-count-pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  background: var(--clr-surface);
  border: 1px solid var(--clr-border);
  font-family: var(--font-primary);
  font-size: 11px;
  font-weight: 600;
  color: var(--clr-text-secondary);
}

.fs-btn {
  display: inline-flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 10px;
  border: 1.5px solid rgba(0,0,0,0.15);
  background: #ffffff;
  font-family: var(--font-primary);
  font-size: 12px;
  font-weight: 600;
  color: #3d4a5c;
  cursor: pointer;
  transition: background 0.18s, border-color 0.18s, box-shadow 0.18s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  white-space: nowrap;
  outline: none;
}

.fs-btn:hover {
  background: #f4f6f9;
  border-color: rgba(0,0,0,0.25);
  box-shadow: 0 2px 6px rgba(0,0,0,0.10);
}

.fs-btn:active {
  transform: scale(0.97);
}

.fs-btn .v-icon {
  color: #5A6476 !important;
}

@media (max-width: 600px) {
  .fs-btn-label { display: none; }
  .fs-btn { padding: 8px 10px; }
}

/* ===================================================
   DASHBOARD CARD
   =================================================== */
.dashboard-card.v-card {
  background: transparent !important;
  border: none !important;
}

.dashboard-body.v-card__text {
  padding: 0 12px 24px !important;
}

/* ===================================================
   ALERTS PANEL
   =================================================== */
.alerts-panel .v-expansion-panel {
  border-radius: 12px !important;
  border: 1px solid var(--clr-border) !important;
  box-shadow: none !important;
  background: #fff !important;
}

.alerts-header {
  font-family: var(--font-primary) !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: var(--clr-text-secondary) !important;
  min-height: 48px !important;
}

/* ===================================================
   AREA SELECT
   =================================================== */
.area-select.v-input {
  background: #fff;
  border-radius: 10px;
  font-family: var(--font-primary) !important;
  font-size: 13px !important;
}

/* ===================================================
   FILTER CHIPS
   =================================================== */
.filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-radius: 30px;
  border: 1.5px solid var(--clr-border);
  background: #fff;
  font-family: var(--font-primary);
  font-size: 12px;
  font-weight: 500;
  color: var(--clr-text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
}

.filter-chip:hover {
  border-color: rgba(0,0,0,0.18);
  background: var(--clr-surface);
}

.chip-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.chip-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: var(--clr-surface);
  font-size: 10px;
  font-weight: 700;
  color: var(--clr-text-muted);
  margin-left: 2px;
}

.filter-chip.active .chip-count {
  background: currentColor;
}

/* Ocultar el chip-count cuando está activo (hereda color del texto) */
.filter-chip.active .chip-count {
  opacity: 0.25;
}

/* ===================================================
   LOADING
   =================================================== */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  gap: 16px;
}

.loading-text {
  font-family: var(--font-primary);
  font-size: 14px;
  font-weight: 500;
  color: var(--clr-text-muted);
}

/* ===================================================
   FULLSCREEN
   =================================================== */
.maquina-estado-root:fullscreen {
  padding: 20px;
  overflow: hidden;
  height: 100vh;
  background: #F4F6F9;
}

.maquina-estado-root:fullscreen .dashboard-body.v-card__text {
  max-height: calc(100vh - 96px);
  overflow: hidden;
}

/* ===================================================
   RESPONSIVE
   =================================================== */
@media (max-width: 600px) {
  .toolbar-row   { padding: 12px 14px 8px; }
  .toolbar-title { font-size: 13px; }
  .filter-chip   { font-size: 11px; padding: 5px 10px; }
  .dashboard-body.v-card__text { padding: 0 6px 16px !important; }

  .fs-btn.v-btn .v-btn__content span:not(.v-icon) {
    display: none;
  }
}

@media (min-width: 3200px) {
  .toolbar-title  { font-size: 1.4rem; }
  .filter-chip    { font-size: 1rem; padding: 10px 20px; }
  .machine-count-pill { font-size: 0.95rem; }
}
</style>